<template>
  <WizardContent
    :graphic="{
      type: 'gradient',
      assetsPath: 'image-setting-up',
    }"
  >
    <h4 class="mt-6 mb-9">
      Great News {{ firstName }}! We're setting up your account.
    </h4>
    <p class="p3 mb-6">
      We have everything we need to determine your account eligibility and get everything set up.
      You'll receive an email just as soon as we're finished.
    </p>
    <p class="p3">
      Account setup typically takes about an hour but can vary on weekends and holidays.
    </p>
  </WizardContent>
</template>

<script>
import WizardContent from '@/components/shared/WizardContent.vue';
import { mapState } from 'pinia';
import { useWizard } from '@/stores/wizard/wizard';

export default {
  name: 'AccountBeingSetup',
  components: {
    WizardContent,
  },
  emits: ['track-page-load'],
  computed: {
    ...mapState(useWizard, ['firstName']),
  },
  async created() {
    if (window.gtag) {
      window.gtag('event', 'conversion', { send_to: 'AW-873652164/Vhx8CL-r8ocBEMS_y6AD' });
    }
  },
  beforeCreate() {
    this.$emit('track-page-load', { page: 'Account Being Setup' });
  },
};
</script>
